// import React from 'react';
import { isNullOrUndefined } from 'utils/object-utils';

// import MultilineEllipsis from 'components/common/multi-line-ellipsis-text-component';
import DataGridColumn from 'models/utils/common/data-grid/data-grid-column-model';

import { getWorkpapersWithoutTrialBalance } from 'constants/feature/tieout-element-constants';
// const REPORT_PREVIEW_COLUMN = 'report_preview_column';
const ITEM_HEIGHT = 48;

export const SCALING_TYPES = {
  1: 'Ones',
  2: 'Thousands',
  3: 'Millions',
  4: 'Billions',
  5: 'Thousands',
  6: 'Other',
  7: 'Lakhs',
  8: 'Crores',
};

export const UNIT_TYPES = {
  1: 'Currency',
  2: 'Percentage',
  3: 'Shares',
  4: 'Text',
  5: 'Other',
};

const statusConstants = {
  STATUS_REVIEWED_FLAGGED: 'Reviewed and Flagged',
  STATUS_REVIEWED: 'Reviewed',
  STATUS_VERFIED_FLAGGED: 'Verified and Flagged',
  STATUS_VERIFIED: 'Verified',
  STATUS_UNVERIFIED_FLAGGED: 'Unverified and Flagged',
  STATUS_UNVERIFIED: 'Unverified',
};

const buildStatus = (elementEntity) => {
  let elementFlagged = false;
  if (
    elementEntity.flagInternalRef ||
    elementEntity.flagUser ||
    elementEntity.flagFormula ||
    elementEntity.flagOverride
  ) {
    elementFlagged = true;
  }
  if (elementEntity.reviewed) {
    return elementFlagged
      ? statusConstants.STATUS_REVIEWED_FLAGGED
      : statusConstants.STATUS_REVIEWED;
  } else if (elementEntity.internalVerified) {
    return elementFlagged
      ? statusConstants.STATUS_VERFIED_FLAGGED
      : statusConstants.STATUS_VERIFIED;
  } else {
    return elementFlagged
      ? statusConstants.STATUS_UNVERIFIED_FLAGGED
      : statusConstants.STATUS_UNVERIFIED;
  }
};

export const getElementReoprtColumns = ({
  reportPreviewPageDisplayOptions,
  reOrederedOptions,
}) => {
  let elementReportColumns = {
    elementId: new DataGridColumn({
      key: 'id',
      header: 'statement-review.table.column.elementId',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        return rowData.previewSequenceID;
      },
    }),
    displayValue: new DataGridColumn({
      key: 'display',
      header: 'statement-review.table.column.display',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        return rowData.display;
      },
    }),
    scaledValue: new DataGridColumn({
      key: 'amount',
      header: 'statement-review.table.column.actual',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        return rowData?.amount;
      },
    }),
    pageNo: new DataGridColumn({
      key: 'sectionId',
      header: 'statement-review.table.column.sectionId',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        return rowData.sectionId;
      },
    }),
    label: new DataGridColumn({
      key: 'label',
      header: 'statement-review.table.column.label',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        return rowData.label;
      },
    }),
    status: new DataGridColumn({
      key: 'status',
      header: 'statement-review.table.column.status',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        const status = buildStatus(rowData);
        return status;
      },
    }),
    workpaper: new DataGridColumn({
      key: 'workpaperReferenceNumbers',
      header: 'statement-review.table.column.workpaper',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        const workpapers =
          rowData &&
          rowData.elementAnnotations &&
          rowData.elementAnnotations.workpaperReferenceNumberList &&
          getWorkpapersWithoutTrialBalance(
            rowData.elementAnnotations.workpaperReferenceNumberList,
          )
            .map((wp) => wp.split('|')[0])
            .join(', ');
        return workpapers;
      },
    }),
    tickmarks: new DataGridColumn({
      key: 'tickmarks',
      header: 'statement-review.table.column.tickmark',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        const tickmarks =
          rowData &&
          rowData.elementAnnotations &&
          rowData.elementAnnotations.tickmarks &&
          rowData.elementAnnotations.tickmarks.replace(/}{/g, '},{');
        return tickmarks;
      },
    }),
    formula: new DataGridColumn({
      key: 'formulaCell',
      header: 'statement-review.table.column.formula',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        return rowData.formulaCell;
      },
    }),
    internalRef: new DataGridColumn({
      key: 'internalReference',
      header: 'statement-review.table.column.internalreference',
      width: '160px',
      formatter: (rowData) => {
        const internalReference =
          rowData &&
          rowData.elementAnnotations &&
          rowData.elementAnnotations.irGroupName;
        return internalReference;
      },
    }),
    comfortLetter: new DataGridColumn({
      key: 'comfortLetterlabelList',
      header: 'statement-review.table.column.comfortletter',
      width: '160px',
      className: 'comfort-letter',
      formatter: (rowData, { rowKey }) => {
        const comfortLetters =
          rowData &&
          rowData.elementAnnotations &&
          rowData.elementAnnotations.comfortLetterDto &&
          rowData.elementAnnotations.comfortLetterDto
            .map((item) => `[${item.label}]- ${item.text}`)
            .join(', ');
        return comfortLetters;
      },
    }),
    scaling: new DataGridColumn({
      key: 'scaling',
      header: 'statement-review.table.column.scaling',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        return SCALING_TYPES[rowData.scalingId];
      },
    }),
    units: new DataGridColumn({
      key: 'units',
      header: 'statement-review.table.column.units',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        return UNIT_TYPES[rowData.unitsId];
      },
    }),
    period: new DataGridColumn({
      key: 'period',
      header: 'statement-review.table.column.period',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        return rowData.periodType + rowData.fiscalYear;
      },
    }),
    entity: new DataGridColumn({
      key: 'entity',
      header: 'statement-review.table.column.entity',
      width: '160px',
      formatter: (rowData, { rowKey }) => {
        return rowData.entity;
      },
    }),
  };

  const elementColumns = [];

  Object.keys(elementReportColumns).forEach((item) => {
    if (reportPreviewPageDisplayOptions[item]) {
      elementColumns.push(elementReportColumns[item]);
    }
  });

  return reOrederedOptions && reOrederedOptions.length
    ? reOrederedOptions.flatMap(
        (option) =>
          elementColumns.find((item) => item.key === option.reOrderKey) || [],
      )
    : elementColumns;
};

export const getElementListBySections = (sectionsInView, elementCache) => {
  const elementList = [];
  for (let i of sectionsInView) {
    const sectionElementDetails = elementCache[i];
    if (
      !isNullOrUndefined(sectionElementDetails) &&
      sectionElementDetails.isLoaded
    ) {
      const elements = Object.values(sectionElementDetails.elements);
      elementList.push(...elements);
    }
  }
  return elementList;
};

export const getElementPositionInElementList = (
  elementId,
  elementReportData,
) => {
  const index =
    !isNullOrUndefined(elementId) &&
    elementReportData.findIndex(
      (element) => parseInt(element.id) === elementId,
    );

  const position = index * ITEM_HEIGHT;
  return position;
};
